// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__255Z3","logo":"Header_logo__2lWvW","title":"Header_title__34MEX"};